export const QUERY_PARAM_KEYS = {
  source: 'source',
  state: 'state',
  paymentType: 'paymentType',
  selectedDate: 'date',
  sourceType: 'source-type',
  user: 'sessionHash',
};

export const QUERY_PARAM_VALUES = {
  TRANSACTION: 'transaction',
  SUCCESS: 'success',
  SOURCE_INTERNAL: 'internal',
  LATER: 'later',
};
